import { render, staticRenderFns } from "./commodityList.vue?vue&type=template&id=4f26dcca&scoped=true&"
import script from "./commodityList.vue?vue&type=script&lang=js&"
export * from "./commodityList.vue?vue&type=script&lang=js&"
import style0 from "./commodityList.vue?vue&type=style&index=0&id=4f26dcca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f26dcca",
  null
  
)

export default component.exports